import { render, staticRenderFns } from "./AddNewColor.vue?vue&type=template&id=6e1f6e0c&scoped=true"
import script from "./AddNewColor.vue?vue&type=script&lang=js"
export * from "./AddNewColor.vue?vue&type=script&lang=js"
import style0 from "./AddNewColor.vue?vue&type=style&index=0&id=6e1f6e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1f6e0c",
  null
  
)

export default component.exports